// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__h6KUs","head":"Table_head__2S-k_","col":"Table_col__3eFXp"};